// extracted by mini-css-extract-plugin
module.exports = {"customScrollBar":"product-details_customScrollBar__III8D"};